/* 検索バーのジャンル連動サジェスト（トレカショップサーカス カスタム）
   2026-08-23

   ■ 仕組み
   入力するたびに `/search?q=...&type=product&view=suggest` を叩く。
   ジャンルが選ばれていれば `&filter.p.m.custom.genre=...` を足す。
   → Shopifyの検索とフィルターをそのまま使うので、日本語検索の精度も絞り込みも標準どおり。
     （標準の /search/suggest.json はフィルター非対応なので使っていない。理由は templates/search.suggest.liquid のコメント参照）

   ■ 設計上の注意
   ・入力のたびに叩かないよう 250ms のデバウンスをかけている。
   ・前のリクエストは AbortController で確実に捨てる。遅れて返ってきた古い結果で
     新しい結果を上書きしないため（この手のUIで一番多い不具合）。
   ・JSが動かなくてもフォームの submit は生きているので、検索機能自体は失われない。
   ・ランクバッジの色は JSON の rank_color / rank_fg を CSS変数で注入する（2026-09-02追加）。
     色はサーバ(metaobject badge_color)由来だが、style属性に入れるので hex 形式だけ許可してサニタイズ。 */
(function () {
  var DEBOUNCE_MS = 250;
  var MIN_LENGTH = 1;

  function init(root) {
    var input = root.querySelector('[data-suggest-input]');
    var genre = root.querySelector('[data-suggest-genre]');
    var panel = root.querySelector('[data-suggest-panel]');
    var searchUrl = root.getAttribute('data-search-url') || '/search';
    if (!input || !panel) return;

    var timer = null;
    var controller = null;
    var activeIndex = -1;

    function close() {
      panel.hidden = true;
      panel.innerHTML = '';
      activeIndex = -1;
      input.setAttribute('aria-expanded', 'false');
    }

    function buildUrl(term) {
      var url = searchUrl + '?q=' + encodeURIComponent(term) + '&type=product&view=suggest';
      if (genre && genre.value) {
        url += '&filter.p.m.custom.genre=' + encodeURIComponent(genre.value);
      }
      return url;
    }

    function allResultsUrl(term) {
      var url = searchUrl + '?q=' + encodeURIComponent(term) + '&type=product';
      if (genre && genre.value) {
        url += '&filter.p.m.custom.genre=' + encodeURIComponent(genre.value);
      }
      return url;
    }

    function escapeHtml(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    // style属性に入れる色は hex（#rgb / #rrggbb / #rrggbbaa 等）だけ許可する
    function safeColor(c) {
      return /^#[0-9a-fA-F]{3,8}$/.test(String(c || '')) ? c : '';
    }

    function rankBadge(p) {
      if (!p.rank) return '';
      var bg = safeColor(p.rank_color);
      var fg = safeColor(p.rank_fg);
      var style = bg ? ' style="--rank-color:' + bg + ';--rank-fg:' + (fg || '#2a2a2a') + ';"' : '';
      return (
        '<span class="condition-badge condition-badge--' +
        String(p.rank).toLowerCase() +
        ' is-selected"' + style + '>' +
        '<span class="condition-badge__label">' + escapeHtml(p.rank) + '</span></span>'
      );
    }

    function render(data, term) {
      var products = (data && data.products) || [];

      if (!products.length) {
        panel.innerHTML = '<p class="card-suggest__empty">該当する商品が見つかりませんでした</p>';
        panel.hidden = false;
        input.setAttribute('aria-expanded', 'true');
        return;
      }

      var html = '<ul class="card-suggest__list" role="listbox">';
      products.forEach(function (p, i) {
        var img = p.image
          ? '<img class="card-suggest__thumb" src="' + p.image + '" alt="" loading="lazy" width="40" height="40">'
          : '<span class="card-suggest__thumb card-suggest__thumb--empty" aria-hidden="true"></span>';

        var rank = rankBadge(p);

        html +=
          '<li role="option" id="card-suggest-opt-' + i + '" aria-selected="false">' +
          '<a class="card-suggest__item" href="' + p.url + '">' +
          img +
          '<span class="card-suggest__body">' +
          '<span class="card-suggest__title">' + escapeHtml(p.title) + '</span>' +
          '<span class="card-suggest__meta">' + rank +
          '<span class="card-suggest__price">' + escapeHtml(p.price || '') + '</span>' +
          '</span></span></a></li>';
      });
      html += '</ul>';

      var total = data.count || products.length;
      if (total > products.length) {
        html += '<a class="card-suggest__more" href="' + allResultsUrl(term) + '">すべての結果を見る（' + total + '件）</a>';
      }

      panel.innerHTML = html;
      panel.hidden = false;
      activeIndex = -1;
      input.setAttribute('aria-expanded', 'true');
    }

    function fetchSuggest() {
      var term = input.value.trim();
      if (term.length < MIN_LENGTH) {
        close();
        return;
      }

      if (controller) controller.abort();
      controller = new AbortController();

      fetch(buildUrl(term), { signal: controller.signal })
        .then(function (res) {
          if (!res.ok) throw new Error('suggest request failed: ' + res.status);
          return res.text();
        })
        .then(function (text) {
          render(JSON.parse(text), term);
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          close();
        });
    }

    function schedule() {
      clearTimeout(timer);
      timer = setTimeout(fetchSuggest, DEBOUNCE_MS);
    }

    function options() {
      return panel.querySelectorAll('[role="option"]');
    }

    function highlight(next) {
      var opts = options();
      if (!opts.length) return;
      if (activeIndex >= 0 && opts[activeIndex]) {
        opts[activeIndex].setAttribute('aria-selected', 'false');
        opts[activeIndex].classList.remove('is-active');
      }
      activeIndex = next;
      if (activeIndex < 0) activeIndex = opts.length - 1;
      if (activeIndex >= opts.length) activeIndex = 0;
      opts[activeIndex].setAttribute('aria-selected', 'true');
      opts[activeIndex].classList.add('is-active');
      opts[activeIndex].scrollIntoView({ block: 'nearest' });
    }

    input.addEventListener('input', schedule);
    input.addEventListener('focus', function () {
      if (input.value.trim().length >= MIN_LENGTH && panel.innerHTML === '') schedule();
    });

    // ジャンルを変えたら、入力済みのキーワードで引き直す（＝サジェストもジャンル連動）
    if (genre) {
      genre.addEventListener('change', function () {
        if (input.value.trim().length >= MIN_LENGTH) fetchSuggest();
      });
    }

    input.addEventListener('keydown', function (event) {
      if (panel.hidden) return;
      if (event.key === 'ArrowDown') {
        event.preventDefault();
        highlight(activeIndex + 1);
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        highlight(activeIndex - 1);
      } else if (event.key === 'Enter') {
        var opts = options();
        if (activeIndex >= 0 && opts[activeIndex]) {
          event.preventDefault();
          var link = opts[activeIndex].querySelector('a');
          if (link) window.location.href = link.href;
        }
      } else if (event.key === 'Escape') {
        close();
      }
    });

    document.addEventListener('click', function (event) {
      if (!root.contains(event.target)) close();
    });
  }

  function boot() {
    var roots = document.querySelectorAll('[data-card-suggest]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
